import { render, staticRenderFns } from "./OpenTel.vue?vue&type=template&id=28756a0d"
import script from "./OpenTel.vue?vue&type=script&lang=js"
export * from "./OpenTel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports